<template>
    <div id="leftMenu">
        <el-menu v-if="!$root.isMob()" class="leftMenu" :default-active="activeIndex" @select="handleSelect">
            <el-menu-item index="home">
                <i class="el-icon-menu"></i>
                <span slot="title">我的主页</span>
            </el-menu-item>
            <el-submenu index="unityMenu">
                <template slot="title">
                    <i class="el-icon-s-platform"></i>
                    <span>数智中心</span>
                </template>
                <el-menu-item index="unity">数智WEB</el-menu-item>
                <el-menu-item v-if="isshow === 0" index="unityVr">数智VR</el-menu-item>
                <el-menu-item v-if="isshow === 0" index="unityLog">考核记录</el-menu-item>
                <el-menu-item v-if="isshow === 0" index="unityTestLog">练习记录</el-menu-item>
            </el-submenu>

            <el-submenu v-if="isshow === 0" index="testsMenu">
                <template slot="title">
                    <i class="el-icon-s-order"></i>
                    <span>理论考核</span>
                </template>
                <el-menu-item index="tests">试卷答题</el-menu-item>
                <el-menu-item index="testsLog">答题记录</el-menu-item>
            </el-submenu>

            <el-submenu v-if="isshow === 0" index="practiceMenu">
                <template slot="title">
                    <i class="el-icon-s-claim"></i>
                    <span>理论练习</span>
                </template>
                <el-menu-item index="practice">试卷答题</el-menu-item>
                <el-menu-item index="practiceLog">答题记录</el-menu-item>
            </el-submenu>

            <!-- <el-menu-item index="modelShow">
                <i class="el-icon-s-help"></i>
                <span slot="title">模型展示</span>
            </el-menu-item> -->

            <el-menu-item v-if="isshow === 0" index="learn">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">云课堂</span>
            </el-menu-item>

            <el-menu-item index="info">
                <i class="el-icon-s-custom"></i>
                <span slot="title">个人资料</span>
            </el-menu-item>
        </el-menu>
        <div v-if="!$root.isMob()" class="footer">
            <div>
                Powered by <img :src="logo">
            </div>
        </div>

        <div v-if="$root.isMob()" class="mobMenu" @click="isShowMobMenu = true">
            <i class="el-icon-menu"></i>
        </div>
        <el-drawer v-if="$root.isMob()" title="Menu" size="60%" :visible.sync="isShowMobMenu" direction="ltr">
            <el-menu class="leftMenu" :default-active="activeIndex" @select="handleSelect">
                <el-menu-item index="home">
                    <i class="el-icon-menu"></i>
                    <span slot="title">我的主页</span>
                </el-menu-item>
                <el-submenu index="unityMenu">
                    <template slot="title">
                        <i class="el-icon-s-platform"></i>
                        <span>数智中心</span>
                    </template>
                    <el-menu-item index="unity">数智网页</el-menu-item>
                    <el-menu-item v-if="isshow === 0" index="unityVr">数智VR</el-menu-item>
                    <el-menu-item v-if="isshow === 0" index="unityLog">考核记录</el-menu-item>
                    <el-menu-item v-if="isshow === 0" index="unityTestLog">练习记录</el-menu-item>
                </el-submenu>

                <el-submenu v-if="isshow === 0" index="testsMenu">
                    <template slot="title">
                        <i class="el-icon-s-order"></i>
                        <span>理论考核</span>
                    </template>
                    <el-menu-item index="tests">试卷答题</el-menu-item>
                    <el-menu-item index="testsLog">答题记录</el-menu-item>
                </el-submenu>

                <el-submenu v-if="isshow === 0" index="practiceMenu">
                    <template slot="title">
                        <i class="el-icon-s-claim"></i>
                        <span>理论练习</span>
                    </template>
                    <el-menu-item index="practice">试卷答题</el-menu-item>
                    <el-menu-item index="practiceLog">答题记录</el-menu-item>
                </el-submenu>
                <!-- 模型展示手机版 -->
                <!-- <el-menu-item index="modelShow">
                    <i class="el-icon-s-help"></i>
                    <span slot="title">模型展示</span>
                </el-menu-item> -->

                <el-menu-item v-if="isshow === 0" index="learn">
                    <i class="el-icon-notebook-2"></i>
                    <span slot="title">云课堂</span>
                </el-menu-item>

                <el-menu-item index="info">
                    <i class="el-icon-s-custom"></i>
                    <span slot="title">个人资料</span>
                </el-menu-item>

                <el-menu-item index="logout">
                    <i class="el-icon-switch-button"></i>
                    <span slot="title">退出</span>
                </el-menu-item>
            </el-menu>
            <div class="footer mob">
                <div>
                    Powered by <img :src="logo">
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import logo from '@/assets/img/logo_footer.png';

export default {
    data() {
        return {
            activeIndex: 'home',
            logo: logo,
            isShowMobMenu: false,
            isshow:1
        }
    },
    props: {
        menuIndex: {
            type: String,
            default: 'home'
        }
    },
    watch: {
        "menuIndex"() {
            this.activeIndex = this.menuIndex;
        }
    },
    methods: {
        handleSelect(key) {
            if (key == 'logout') {
                this.$root.logout();
            }
            this.isShowMobMenu = false;
            this.activeIndex = key;
            localStorage.setItem('menuActive', key);
            this.$emit('change', key);
        },

        async isshowlib() {
            this.userInfo = await this.$root.getUserInfo();     
            this.isshow = this.userInfo.settled_unit_branch_id;
        }
    },
    created() {
        if (this.$root.isMob() && this.$route.query.isFromHome) {
            this.isShowMobMenu = true;
        }
        this.isshowlib();
    },
    mounted() {
    }
}
</script>
<style lang="scss" scoped src="@/assets/css/lib/leftMenu.scss"></style>